<template>
  <div class="home w-100">
      <div class="row h-100 justify-content-center align-items-center">
            <div class="col-sm-6">
            <div class="row h-100 justify-content-center align-items-center">
                <h2>Register</h2>
            </div>
                <form class="text-center" id="form-register" method="post" @submit.prevent="register">
                <div class="row form-group">
                    <div class="col-3">
                    <label for="">E-Mail :</label>
                    </div>
                    <div class="col-sm-7">
                    <input class="form-control" name="email" type="email" placeholder="***@gafa.co.nz" id="email" >
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-3">
                    <label for="">First Name :</label>
                    </div>
                    <div class="col-7">
                    <input name="fname" class="form-control" type="text"  id="fname" >
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-3">
                    <label for="">Last Name :</label>
                    </div>
                    <div class="col-7">
                    <input name="lname" class="form-control" type="text"  id="lname" >
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-3">
                    <label for="">Password :</label>
                    </div>
                    <div class="col-7">
                    <input @ class="form-control" name="password" 
                    type="password" id="password" 
                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" 
                    title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters" 
                    required
                    @focus="passFocus"
                    @blur="passBlur"
                    v-on:keyup="passkeyUp">
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-8" id="message">
                        <h6>Password must contain the following:</h6>
                        <p id="letter" class="invalid">A <b>lowercase</b> letter</p>
                        <p id="capital" class="invalid">A <b>capital (uppercase)</b> letter</p>
                        <p id="number" class="invalid">A <b>number</b></p>
                        <p id="length" class="invalid">Minimum <b>8 characters</b></p>
                    </div>
                </div>

                <div style="padding: 0;" class="row form-group">
                    <div class="col-3">
                    <label for="">Password Confirm :</label>
                    </div>
                    <div class="col-7">
                    <input class="form-control" type="password"  id="password2" >
                    </div>

                </div>

                    <button class="btn btn-primary" type="submit" name="button">Register</button>


                </form>
            </div>
        </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import {mapState,mapMutations} from 'vuex'
import axios from 'axios'
//import VueSweetAlert from 'vue-sweetalert'
export default {
  name: 'Register',
  data(){
    return{
      
    }
  },
  components: {

  },
  computed:{
  },
  methods:{
      passFocus(){
          document.getElementById("message").style.display = "block";
      },
      passBlur(){
          document.getElementById("message").style.display = "none";
      },
      passkeyUp(){
            var myInput = document.getElementById("password");
            var letter = document.getElementById("letter"); 
            var capital = document.getElementById("capital");
            var number = document.getElementById("number");
            var length = document.getElementById("length");
            var passwordcheck=0;
            // Validate lowercase letters
            var lowerCaseLetters = /[a-z]/g;
            if(myInput.value.match(lowerCaseLetters)) {
                letter.classList.remove("invalid");
                letter.classList.add("valid");
                passwordcheck++;
            } else {
                letter.classList.remove("valid");
                letter.classList.add("invalid");
            }

            // Validate capital letters
            var upperCaseLetters = /[A-Z]/g;
            if(myInput.value.match(upperCaseLetters)) {
                capital.classList.remove("invalid");
                capital.classList.add("valid");
                passwordcheck++;
            } else {
                capital.classList.remove("valid");
                capital.classList.add("invalid");
            }

            // Validate numbers
            var numbers = /[0-9]/g;
            if(myInput.value.match(numbers)) {
                number.classList.remove("invalid");
                number.classList.add("valid");
                passwordcheck++;
            } else {
                number.classList.remove("valid");
                number.classList.add("invalid");
            }

            // Validate length
            if(myInput.value.length >= 8) {
                length.classList.remove("invalid");
                length.classList.add("valid");
                passwordcheck++;
            } else {
                length.classList.remove("valid");
                length.classList.add("invalid");
            }

            // validate password - change border color
            if(passwordcheck>=4){
                myInput.classList.remove("invalidborder");
            }else{
                myInput.classList.add("invalidborder");
            }
      },
      register(){ 
        
          
            var email=document.querySelector('#email').value;
            var fname=document.querySelector('#fname').value;
            var lname=document.querySelector('#lname').value;
            var password=document.querySelector('#password').value;
            var password2=document.querySelector('#password2').value;

            var emailUpper = email.toUpperCase();


            //validations
            if(email.trim()==''){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Email is empty!'
                })
            }else if(fname.trim()==''){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'First name is empty!'
                })
            }else if(lname.trim()==''){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Last name is empty!'
                })
            }else if(password.trim()==''){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Password is empty!'
                })
            }else if(password2!=password){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Pasword does not match!'
                })
            }else if(emailUpper.indexOf('@GAFA.CO.NZ')==-1){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Please enter correct email address (ex: ***@gafa.co.nz)'
                })
            }else{
                var form = document.getElementById('form-register');
                axios.post('http://localhost:80/newgafa/src/models/Register.php', new FormData(form))
                //axios.post('http://gafa.co.nz/models/Register.php', new FormData(form))
                .then(res =>{
                    if(res.data.rta=='0'){

                        this.$swal({
                        title: 'success',
                        text: 'successful',
                        type: 'success'
                        }).then(() => {
                            this.$router.push({ path: '/login' });                            
                        })

                    }else if(res.data.rta=='1'){
                        this.$swal({
                            type: 'error',
                            title: 'Error',
                            text: 'connection problem, try again later please'
                        })
                    }else if(res.data.rta=='2'){
                        this.$swal({
                            type: 'error',
                            title: 'Error',
                            text: 'The email address is already exists'
                        })
                    }
                    
                })
            }
      }

      
  },
  created(){
    
  }
}
</script>


<style>

</style>
